/** @jsx jsx */
import { jsx } from "@emotion/react";

import appConfig from "../../modules/appConfig";

export const OtherIssues = (): React.ReactElement | null => {
  const { otherIssues } = appConfig;

  return otherIssues.length > 0 ? (
    <ul>
      {otherIssues.map((issue) => (
        <li key={issue.title}>
          <a href={issue.url}>{issue.title}</a>
        </li>
      ))}
    </ul>
  ) : null;
};

export default OtherIssues;
